import { useMemo } from 'react';
import { Dropdown } from '@geberit/gdds';

// styles
import styles from './investors-calendar.module.scss';

// types
import type { SelectOption } from '@geberit/gdds/dist/esm/form/Dropdown/types/Dropdown.types';
import type { EventsSorted } from './investors-calendar.types';

// components
import EventsContent from './events-content';

// utils
import { getSortedEvents } from './utils';

interface InvestorDropdownProps {
  futureEventsTitle: string;
  pastEventsTitle: string;
  locale: Locale;
  currentYear: number;
  setCurrentYear: (year: number) => void;
  events: EventsSorted;
  language: string;
}

function InvestorDropdown({
  futureEventsTitle,
  events,
  currentYear,
  setCurrentYear,
  locale,
  pastEventsTitle,
  language,
}: Readonly<InvestorDropdownProps>) {
  const years = useMemo<SelectOption[]>(() => {
    let yearItems: SelectOption[] = [];
    events.forEach((event) => {
      const text = String(event.year);
      yearItems.push({ id: text, value: text, text });
    });
    return yearItems;
  }, [events]);

  const sortedEvents = useMemo(() => {
    const initialIndex = events.findIndex((item) => item.year === currentYear);
    const [upcoming, past] = getSortedEvents(events[initialIndex]);
    return { upcoming, past };
  }, [currentYear, events]);

  const onChange = (option) => {
    setCurrentYear(parseInt(option.value));
  };

  return (
    <>
      <div className={styles.dropdownContainer}>
        <Dropdown
          items={years}
          onChange={onChange}
          defaultValue={String(currentYear)}
          values={{ years: String(currentYear) }}
          name="years"
          outlined
        />
      </div>
      <EventsContent
        pastEvents={sortedEvents.past}
        upcomingEvents={sortedEvents.upcoming}
        futureEventsTitle={futureEventsTitle}
        pastEventsTitle={pastEventsTitle}
        locale={locale}
        language={language}
      />
    </>
  );
}

export default InvestorDropdown;
